const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const istanbul = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit'
});

function calendarDate(year, month, day) {
  const date = new Date(0);
  date.setUTCFullYear(Number(year), Number(month) - 1, Number(day));
  if (date.getUTCFullYear() !== Number(year) || date.getUTCMonth() + 1 !== Number(month) || date.getUTCDate() !== Number(day)) return '';
  return `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

// Stored calendar dates have no time zone. Only actual timestamps need conversion.
export function normalizeOrderDate(value) {
  if (value === null || value === undefined || value === '') return '';
  if (typeof value === 'string') {
    const text = value.trim();
    const civil = /^(\d{4})-(\d{2})-(\d{2})$/.exec(text);
    if (civil) return calendarDate(civil[1], civil[2], civil[3]);
    const legacy = /^(?:[A-Za-z]{3} )?([A-Za-z]{3}) (\d{1,2}) (\d{4})$/.exec(text);
    if (legacy) return calendarDate(legacy[3], months.indexOf(legacy[1]) + 1, legacy[2]);
    const localTime = /^(\d{4})-(\d{2})-(\d{2})T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/.exec(text);
    if (localTime) return calendarDate(localTime[1], localTime[2], localTime[3]);
  }
  try {
    const date = typeof value?.toDate === 'function' ? value.toDate() : new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    const parts = istanbul.formatToParts(date);
    return ['year', 'month', 'day'].map(type => parts.find(part => part.type === type).value).join('-');
  } catch {
    return '';
  }
}
